import { render, staticRenderFns } from "./diseases_and_symptoms.preview.vue?vue&type=template&id=5137a960&"
import script from "./diseases_and_symptoms.preview.vue?vue&type=script&lang=js&"
export * from "./diseases_and_symptoms.preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports